import Turnstile from "react-turnstile";
import { Button } from "../../../../components/ui";
import { CheckBox } from "../../../../components/ui/inputs/CheckBox";
import { TextInput } from "../../../../components/ui/inputs/TextInput";
import { useState } from "react";
import { PhoneNumberInput } from "../../../../components/ui/inputs/PhoneNumberInput";
import localization from "../../../../config/localization";
import { Validations } from "../../../../models/constants/validations";
import { DeviceType } from "../../../../models/constants/deviceType";
import userDeviceStore from "../../../../store/device.store";
import { PasswordInput } from "../../../../components/ui/inputs";

export const MobileSignup = ({ turnstileSiteKey, onChangeMethod, onSubmit }: { turnstileSiteKey: string, onChangeMethod: () => void, onSubmit: (username: string, password: string, mobile: string, captchaToken?: string | null) => void }) => {

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [isAdult, setIsAdult] = useState(false);
  const [agreed, setAgreed] = useState(false);
  const [usernameError, setUsernameError] = useState<string | null>(null);
  const [passwordError, setPasswordError] = useState<string | null>(null);
  const [mobileNumberError, setMobileNumberError] = useState<string | null>(null);
  const [isAdultError, setIsAdultError] = useState<string | null>(null);
  const [agreedError, setAgreedError] = useState<string | null>(null);
  const [captchaError, setCaptchaError] = useState<string | null>(null);
  const [captchaToken, setCaptchaToken] = useState<string | null>(null);
  const deviceType = userDeviceStore((state) => state.deviceType);

  const clearUsernameErrorOnFocus = () => {
    setUsernameError((prev) => (prev ? null : prev));
  };

  const clearPasswordErrorOnFocus = () => {
    setPasswordError((prev) => (prev ? null : prev));
  };

  const clearMobileNumberErrorOnFocus = () => {
    setMobileNumberError((prev) => (prev ? null : prev));
  };

  const handleUsernameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setUsername(value);
    setUsernameError((prev) => (value ? null : prev));
  };

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setPassword(value);
    setPasswordError((prev) => (value ? null : prev));
  };

  const handleMobileNumberChange = (value: string) => {
    setMobileNumber(value);
    setMobileNumberError((prev) => (value ? null : prev));
  };

  const handleIsAdultChange = () => {
    setIsAdult((prev) => !prev);
    setIsAdultError((prev) => (prev ? null : prev));
  };

  const handleAgreedChange = () => {
    setAgreed((prev) => !prev);
    setAgreedError((prev) => (prev ? null : prev));
  };

  const handleCaptchaChange = (token: string) => {
    setCaptchaToken(token);
    setCaptchaError((prev) => (prev ? null : prev));
  };

  const checkValidation = () => {
    let isValid = true;

    setUsernameError(null);
    setPasswordError(null);
    setMobileNumberError(null);
    setIsAdultError(null);
    setAgreedError(null);
    setCaptchaError(null);

    // Username validation
    if (!username) {
      setUsernameError("error_Username");
      isValid = false;
    }
    else if (!Validations.username.regex.test(username)) {
      setUsernameError("valid_username");
      isValid = false;
    }

    // Password validation
    if (!password) {
      setPasswordError("error_Password");
      isValid = false;
    }
    else if (!Validations.password.regex.test(password)) {
      setPasswordError("valid_password_must_contain");
      isValid = false;
    }

    // Mobile number validation
    if (!mobileNumber) {
      setMobileNumberError("enter_mobile");
      isValid = false;
    }
    else if (!Validations.mobile.regex.test(mobileNumber)) {
      setMobileNumberError("mobile_validation_error");
      isValid = false;
    }

    // Is adult validation
    if (!isAdult) {
      setIsAdultError("OverEighteenYears_message");
      isValid = false;
    }

    // Agreed validation
    if (!agreed) {
      setAgreedError("TandC_message");
      isValid = false;
    }

    // Captcha validation
    if (!captchaToken) {
      setCaptchaError("reCAPTCHA_message");
      isValid = false;
    }

    return isValid;
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (checkValidation()) {
      onSubmit(username, password, mobileNumber, captchaToken);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div>
        <div className="flex items-center justify-between mb-6 rounded-3xl bg-[#1B1B1B] p-2">
          <div className="flex items-center gap-2">
            <img src={"/icons/ic-mobile.svg"} alt="Phone" />
            <span className="text-white font-bold">{localization.phone}</span>
          </div>
          <div className="bg-black rounded-3xl shadow p-1">
            <Button
              className="px-3 py-1  font-medium text-gray-200 rounded-xl hover:bg-gray-800 transition"
              onClick={onChangeMethod}
            >
              {localization.change_method}
            </Button>
          </div>
        </div>

        <div className="space-y-3 mb-4">
          <TextInput
            label={localization.username}
            placeholder={localization.username}
            value={username}
            maxLength={15}
            error={usernameError && localization.getString(usernameError)}
            onFocus={clearUsernameErrorOnFocus}
            onChange={handleUsernameChange}
          />

          <PasswordInput
            label={localization.password}
            placeholder={localization.password}
            value={password}
            maxLength={20}
            error={passwordError && localization.getString(passwordError)}
            onFocus={clearPasswordErrorOnFocus}
            onChange={handlePasswordChange}
          />

          <PhoneNumberInput
            label={localization.mobile_number}
            placeholder={localization.mobile_number}
            value={mobileNumber}
            maxLength={10}
            onChange={handleMobileNumberChange}
            error={mobileNumberError && localization.getString(mobileNumberError)}
            onFocus={clearMobileNumberErrorOnFocus}
          />

        </div >

        <div className="space-y-3 mb-4">
          <CheckBox
            label={localization.over_eighteen_years_old}
            checked={isAdult}
            error={isAdultError && localization.getString(isAdultError)}
            onChange={handleIsAdultChange}
          />
          <CheckBox
            label={localization.i_agree_with_terms_and_conditions}
            checked={agreed}
            error={agreedError && localization.getString(agreedError)}
            onChange={handleAgreedChange}
          />
        </div>

        <div className="mb-4">
          <div className={deviceType === DeviceType.Mobile ? "flex justify-center" : undefined}>
            <Turnstile
              sitekey={turnstileSiteKey}
              theme="dark"
              onVerify={(token) => handleCaptchaChange(token)}
              onExpire={() => setCaptchaToken(null)}
            />
          </div>
          {captchaError && (
            <div
              className={`text-red-500 text-sm mt-1 ${deviceType === DeviceType.Mobile ? "text-center" : "ml-2"}`}
            >
              {localization.getString(captchaError)}
            </div>
          )}
        </div>

        <div>
          <Button
            type="submit"
            className={`mt-2 w-full py-4 rounded-md bg-primary-gradient text-white font-bold shadow hover:opacity-90`}
          >
            <span className="uppercase tracking-wider">{localization.submit}</span>
          </Button>
        </div>
      </div >
    </form>
  );
};
